import React, { Component } from "react";
import {
  Col,
  Row,
  Image,
  Button,
  Spinner,
  FormControl,
  InputGroup,
  FormGroup,
} from "react-bootstrap";
import Progress from "./../SpecficTutor/progress";
import UserReviews from "./../SpecficTutor/UserReviews";
import Availability from "./../TutorDashboard/availability";
import { getSpecificTutor } from "./../../apis/tutorList";
import { getReviewTutor } from "./../../apis/tutorList";
import { getSubjectTutor } from "./../../apis/tutorList";
import { connect } from "react-redux";
import { uploadImage, getSetting } from "./../../apis/tutors";
import { TutorSettingAction } from "./../../redux/actions";
import { InfoModal } from "./../../components/modals/InfoModal";

class PreviewProfile extends Component {
  constructor() {
    super();

    this.state = {
      selectedBtn: 1,
      tutorDetailObj: {},
      tutorReviewObj: {},
      tutorSubjectObj: {},
      totalReview: 0,
      employmentData: [],
      educationData: [],

      scale: {
        communication: 0,
        teachingStyle: 0,
        content: 0,
        interaction: 0,
        knowledge: 0,
        timeliness: 0,
      },
      uploadLoader: false,
      tutorBioLoader: false,
      tutorSubLoader: false,
      tutorReviewLoader: false,
      availability: [
        {
          timeStatus: "Morning",
          time: "Pre 12am",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Afternoon",
          time: "12 - 3pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "unavailable",
            fri: "unavailable",
            sat: "available",
            sun: "unavailable",
          },
        },
        {
          timeStatus: "Late Afternoon",
          time: "4 - 6pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Evening",
          time: "6 - 8pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Late Evening",
          time: "After 8pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
      ],
    };
  }
  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;

    if (tutorSettingData?.userId !== prevProps?.tutorSettingData?.userId) {
      var educationData = tutorSettingData?.tutorDetails?.education.sort(
        function (a, b) {
          return new Date(b.startDate) - new Date(a.startDate);
        }
      );
      var employmentData = tutorSettingData?.tutorDetails?.employment.sort(
        function (a, b) {
          return new Date(b.startDate) - new Date(a.startDate);
        }
      );
      this.setState({
        tutorDetailObj: tutorSettingData,
        employmentData,
        educationData,
      });
    }
  };

  componentDidMount = () => {
    let { scale } = this.state;
    let user = JSON.parse(localStorage.getItem("userDetail"));
    let id = user.user.userId;
    let communication = 0;
    let teachingStyle = 0;
    let content = 0;
    let interaction = 0;
    let knowledge = 0;
    let timeliness = 0;
    let totalReview = 0;
    let tutorSubjectObj = {};
    this.setState({
      tutorBioLoader: true,
      tutorSubLoader: true,
      tutorReviewLoader: true,
    });
    getReviewTutor({
      id,
    })
      .then((res) => {
        this.setState({
          tutorReviewObj: res.data,
        });

        res?.data?.length &&
          res.data.map((scaleObj) => {
            communication = communication + scaleObj.scale.communication;
            teachingStyle = teachingStyle + scaleObj.scale.teachingStyle;
            content = content + scaleObj.scale.content;
            interaction = interaction + scaleObj.scale.interaction;
            knowledge = knowledge + scaleObj.scale.knowledge;
            timeliness = timeliness + scaleObj.scale.timeliness;
          });
        totalReview =
          communication +
          teachingStyle +
          content +
          interaction +
          knowledge +
          timeliness;
        totalReview = totalReview / (res?.data?.length * 6);
        totalReview = totalReview.toFixed(2);
        communication = ((communication / res?.data?.length) * 100) / 5;
        teachingStyle = ((teachingStyle / res?.data?.length) * 100) / 5;
        content = ((content / res?.data?.length) * 100) / 5;
        interaction = ((interaction / res?.data?.length) * 100) / 5;
        knowledge = ((knowledge / res?.data?.length) * 100) / 5;
        timeliness = ((timeliness / res?.data?.length) * 100) / 5;

        scale = {
          communication,
          teachingStyle,
          content,
          interaction,
          knowledge,
          timeliness,
        };
        this.setState({
          scale,
          totalReview,
          tutorReviewLoader: false,
        });
      })
      .catch((err) => console.log(err));

    getSubjectTutor({
      id: id,
    })
      .then((res) => {
        for (var i = 0; i < res.data.length; i++) {
          var u = res.data[i];
          if (tutorSubjectObj.hasOwnProperty(u.level)) {
            let val = tutorSubjectObj[u.level];
            val.push(u.subject);
            tutorSubjectObj[u.level] = val;
          } else {
            tutorSubjectObj[u.level] = [u.subject];
          }
        }
        this.setState({
          tutorSubjectObj,
          tutorSubLoader: false,
        });
      })
      .catch((err) => console.log(err));
    getSetting({ user_id: id })
      .then((res) => {
        this.props.TutorSettingStoreData(res.data);

        var educationData = res.data?.tutorDetails?.education.sort(function (
          a,
          b
        ) {
          return new Date(b.startDate) - new Date(a.startDate);
        });
        var employmentData = res.data?.tutorDetails?.employment.sort(function (
          a,
          b
        ) {
          return new Date(b.startDate) - new Date(a.startDate);
        });
        this.setState({
          tutorDetailObj: res.data,
          employmentData,
          educationData,
          tutorBioLoader: false,
        });
      })
      .catch((err) => console.log(err));
  };
  updateProfilePic = (files) => {
    this.setState({
      imageValidated: true,
    });
    this.setState({
      uploadLoader: true,
    });
    let { tutorDetailObj } = this.state;
    const image = files.target.files[0];
    let formdata = new FormData();
    formdata.append("image", image);
    uploadImage({ typeNo: "0", file: formdata })
      .then((res) => {
        if (res.data.message === "image uploaded successfully") {
          tutorDetailObj.imageUrl = res.data.uploadImagePath;
          this.props.TutorSettingStoreData(tutorDetailObj);
          this.setState({
            tutorDetailObj: tutorDetailObj,
            uploadLoader: false,
          });
        }
      })
      .catch((err) => {});
  };
  checkImagedimension = (imageValidated) => {
    console.log(imageValidated, "=====");
    const { tutorDetailObj } = this.state;
    if (imageValidated) {
    } else {
      tutorDetailObj.imageUrl = "";
      InfoModal(
        "Image dimension error",
        "please select image 800x1200 size"
      );
      this.setState({
        tutorDetailObj,
      });
    }
  };

  imgEl = React.createRef();
  render() {
    const {
      selectedBtn,
      availability,
      tutorDetailObj,
      tutorSubjectObj,
      tutorReviewObj,
      totalReview,
      scale,
      employmentData,
      educationData,
      uploadLoader,
      tutorBioLoader,
      tutorSubLoader,
      tutorReviewLoader,
      imageValidated,
    } = this.state;
    const {
      match: {
        params: { id },
      },
      history: {
        location: { pathname },
      },
    } = this.props;
    let firstName = tutorDetailObj?.firstName;
    let lastName = tutorDetailObj?.lastName;
    let mode = tutorDetailObj?.tutorDetails?.modeOfTeaching;
    let user_id = pathname.split("/")[4];
    let joined =
      tutorDetailObj?.createdAt && tutorDetailObj.createdAt.substring(0, 4);

    return (
      <div
        className="specific-tutor-div profile-preview"
        style={{ marginTop: "0px" }}
      >
        <div
          className="flex-center-center"
          style={{
            height: "70px",
            background: "#2cb46b",
            color: "#fff",
            padding: "0px 66px",
            marginBottom: "80px",
            fontSize: "14px",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0px 20px",
              paddingLeft: "30px",
            }}
          >
            <div className="truncate">
              Preview : This is how parents and students will see your profile
            </div>
            <Button
              className="green-Button"
              style={{
                borderRadius: "8px",
                border: "solid 2px #ffffff",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}
              onClick={() =>
                this.props.history.push(
                  "/tutor-dashboard/TutorSettingBioAndSub"
                )
              }
            >
              {" "}
              Edit profile
            </Button>
          </div>
        </div>
        <div className="profile-border-style" />
        <div className="container p-0">
        <Row className="m-0 padding-to-row">
          <Col lg={3} md={5} sm={6} xs={12} className="p-0 profile-card-col">
            <div className="profile-card">
              <div
                className="flex-center-center image-div"
                style={{ flexDirection: "column" }}
              >
                {tutorBioLoader || uploadLoader ? (
                  <div className="flex-center-center loader-ui">
                    <Spinner animation="grow" />
                  </div>
                ) : (
                  <Image
                    style={{ marginBottom: "10px" }}
                    className="image-profile"
                    src={
                      tutorDetailObj?.imageUrl
                        ? tutorDetailObj.imageUrl
                        : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                    }
                    // ref={this.imgEl}
                    // onLoad={() =>
                    //   this.imgEl?.current?.naturalWidth === 800 &&
                    //   this.imgEl?.current?.naturalHeight === 1200
                    //     ? this.checkImagedimension(true)
                    //     : this.checkImagedimension(false)
                    // }
                  />
                )}
                <img
                  style={{ marginBottom: "10px", display: "none" }}
                  src={
                    tutorDetailObj?.imageUrl
                      ? tutorDetailObj.imageUrl
                      : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                  }
                  ref={this.imgEl}
                  onLoad={() =>
                    this.imgEl?.current?.naturalWidth === 800 &&
                    this.imgEl?.current?.naturalHeight === 1200
                      ? this.checkImagedimension(true)
                      : imageValidated
                      ? this.checkImagedimension(false)
                      : ""
                  }
                />
                <div
                  className="green-txt"
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  Update photo
                  <input
                    onChange={(e) => this.updateProfilePic(e)}
                    type="file"
                    style={{
                      position: "absolute",
                      opacity: "0",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
              <div className="tutor-info-style-div">
                <div className="tutor-hour">
                  <h2>
                    £
                    {tutorDetailObj?.tutorDetails?.hourlyRate
                      ? tutorDetailObj?.tutorDetails.hourlyRate
                      : "20"}
                  </h2>
                  <span>per hour</span>
                </div>
                <div className="tutor-review">
                  <Image
                    src={require("./../../assets/icons/star1.png")}
                    className="pound-img"
                  />
                  <span className="star-span">
                    {totalReview ? totalReview : "N/A"}
                  </span>
                  <span className="rew-span">{`(${
                    tutorReviewObj?.length ? tutorReviewObj?.length : ""
                  } reviews)`}</span>
                </div>
              </div>
              <div
                className="teach-style-div"
                style={{ marginBottom: "20px" }}
              >
                <div>
                  <Image
                    src={require("./../../assets/icons/computer-black.png")}
                  />

                  <span className="status">{` I can teach ${
                    mode === 0
                      ? "online"
                      : mode === 1
                      ? "inperson"
                      : mode === 2
                      ? "online and inperson"
                      : ""
                  }`}</span>
                </div>
                <div>
                  <Image src={require("./../../assets/icons/add-user.png")} />
                  <span className="status">200 taught sessions</span>
                </div>
                <div>
                  <Image src={require("./../../assets/icons/verified.png")} />
                  <span className="status">Verified</span>
                </div>
                <div>
                  <Image
                    src={require("./../../assets/icons/placeholder.png")}
                  />
                  <span className="status">2.53 miles away</span>
                </div>
              </div>
              <div className="submitted-div">
                <div className="name-div">Christopher has submitted</div>
                <div className="values-div flex-center">
                  <Image
                    src={require("./../../assets/icons/correct.png")}
                    style={{ width: "13px", height: "13px" }}
                  />{" "}
                  DBS/ CRB
                </div>
                <div className="values-div flex-center">
                  <Image
                    src={require("./../../assets/icons/correct.png")}
                    style={{ width: "13px", height: "13px" }}
                  />{" "}
                  Qualified teacher{" "}
                </div>
                <div className="values-div flex-center">
                  <Image
                    src={require("./../../assets/icons/correct.png")}
                    style={{ width: "13px", height: "13px" }}
                  />{" "}
                  Examiner
                </div>
              </div>
              <button className="btn btn-success btn-mrgn">Request lesson</button>
              <button className="btn btn-contact btn-cont">Contact tutor</button>
            </div>
          </Col>
          <Col lg={9} md={7} sm={6} xs={12} className="padding-to-second-col">
          <div className="tutor-info-div-detail">
                <p className="truncate headine-title">
                  {tutorDetailObj?.tutorDetails?.tagline
                    ? tutorDetailObj?.tutorDetails?.tagline
                    : "Passionate Maths and Physics tutor"}
                </p>
                <h4 className="truncate headine-sub-title">{`${
                  firstName ? firstName : ""
                } . Joined in ${joined}`}</h4>
                <div className="button-link-div">
                  <a href={`#bio`}>
                    <Button
                      className={`${
                        selectedBtn === 1 ? "active" : ""
                      } first-btn`}
                      onClick={() =>
                        this.setState({
                          selectedBtn: 1,
                        })
                      }
                    >
                      Bio
                    </Button>
                  </a>
                  <a href={`#subject`}>
                    <Button
                      className={`${selectedBtn === 2 ? "active" : ""}`}
                      onClick={() =>
                        this.setState({
                          selectedBtn: 2,
                        })
                      }
                    >
                      Taught subject
                    </Button>
                  </a>
                  <a href={`#review`}>
                    <Button
                      className={`${selectedBtn === 3 ? "active" : ""}`}
                      onClick={() =>
                        this.setState({
                          selectedBtn: 3,
                        })
                      }
                    >
                      Reviews
                    </Button>
                  </a>
                  <a href={`#availabilty`}>
                    <Button
                      className={`${selectedBtn === 4 ? "active" : ""}`}
                      onClick={() =>
                        this.setState({
                          selectedBtn: 4,
                        })
                      }
                    >
                      Availability
                    </Button>
                  </a>
                  <a href={`#workEducation`}>
                    <Button
                      className={`${selectedBtn === 5 ? "active" : ""}`}
                      onClick={() =>
                        this.setState({
                          selectedBtn: 5,
                        })
                      }
                    >
                      Work and education
                    </Button>
                  </a>
                </div>
              </div>
              <div className="about-tutor" id="bio">
                <div>
                  <h2 className="truncate">{`About ${
                    firstName ? firstName : ""
                  }`}</h2>
                  <Image
                    className="quote-img"
                    src={require("./../../assets/icons/quote.png")}
                  />
                  <p className="para-tutor">
                    {tutorDetailObj?.tutorDetails?.bio
                      ? tutorDetailObj?.tutorDetails?.bio
                      : ""}
                  </p>
                  <h2 className="truncate">
                    {` ${firstName ? firstName : ""}`}
                    's teaching style
                  </h2>
                  <p className="para-tutor">
                    {tutorDetailObj?.tutorDetails?.teachingStyle
                      ? tutorDetailObj?.tutorDetails?.teachingStyle
                      : ""}
                  </p>
                </div>
                <hr />
                <div>
                  <h2
                    className="truncate"
                    style={{ marginTop: "40px" }}
                    id="subject"
                  >
                    Taught subjects
                  </h2>
                  {tutorSubLoader ? (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  ) : (
                    <Row style={{ padding: "0px" }}>
                      {Object.keys(tutorSubjectObj).map((subject, index) => {
                        return (
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            key={index}
                            style={{ padding: "0px" }}
                            className="btn-subjects-col"
                          >
                            <h5>{subject}</h5>
                            <div className="btn-div">
                              {tutorSubjectObj[subject]?.length &&
                                tutorSubjectObj[subject][0].map(
                                  (sub, index) => {
                                    return <Button key={index}>{sub}</Button>;
                                  }
                                )}
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  )}

                  <h2
                    className="truncate"
                    style={{ marginTop: "80px" }}
                    id="review"
                  >
                    Student reviews
                  </h2>

                  {tutorReviewLoader ? (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  ) : (
                    <div>
                      <div className="tutor-review">
                        <Image
                          src={require("./../../assets/icons/fillStar.png")}
                          className="pound-img"
                        />
                        <span
                          className="common-para"
                          style={{
                            marginLeft: "10px",
                          }}
                        >
                          {totalReview ? totalReview : "N/A"}

                          <span
                            style={{
                              fontSize: "16px",
                              paddingTop: "0px",
                              margin: "0px 4px",
                            }}
                          >
                            |
                          </span>

                          {`${
                            tutorReviewObj?.length ? tutorReviewObj?.length : ""
                          } reviews`}
                        </span>
                      </div>
                      <Progress scale={scale} />
                      <div style={{ marginBottom: "40px" }} />
                      {tutorReviewObj?.length
                        ? tutorReviewObj.map((review, index) => {
                            return (
                              <UserReviews
                                key={index}
                                review={review}
                                firstName={firstName}
                                lastName={lastName}
                                tutorImg={
                                  tutorDetailObj?.imageUrl
                                    ? tutorDetailObj.imageUrl
                                    : "https://firebasestorage.googleapis.com/v0/b/askademia-36826.appspot.com/o/no-img.png?alt=media&token=139f8f26-4fa9-4cdf-88d7-a27859180a12"
                                }
                              />
                            );
                          })
                        : ""}
                    </div>
                  )}
                </div>
                <h2
                  className="truncate"
                  style={{ marginTop: "40px" }}
                  id="availabilty"
                >
                  Availability
                </h2>
                <h4 style={{ color: "#000" }}>Select availability to book</h4>
                <Availability
                  isSmaller={false}
                  tutor={true}
                  availability={availability}
                  firstName={firstName}
                  lastName={lastName}
                />

                <h2 id="workEducation">Education</h2>
                <div className="flex-between-center head-div">
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Institution</span>
                  </span>
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Qulification</span>
                  </span>
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Date</span>
                  </span>
                </div>
                {tutorBioLoader ? (
                  <div className="flex-center-center">
                    <Spinner
                      animation="border"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                ) : educationData?.length ? (
                  educationData.map((edu, index) => {
                    return (
                      <div key={index} className="h4-head-div">
                        <div className="h4-head-style">
                          <span className="grid-style">
                            {" "}
                            <span className="truncate ">{edu.schoolName}</span>
                          </span>
                          <span className="grid-style">
                            {" "}
                            <span className="truncate ">{edu.degree}</span>
                          </span>
                          <span className="grid-style">
                            {" "}
                            <span className="truncate ">{`${new Date(
                              edu.startDate
                            ).getFullYear()} - ${
                              edu.isCurrent
                                ? "present"
                                : new Date(edu.endDate).getFullYear()
                            }`}</span>
                          </span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  ""
                )}
                <hr />
                <h2 id="workEducation">Employment</h2>
                <div className="flex-between-center head-div">
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Company</span>
                  </span>
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Job title</span>
                  </span>
                  <span className="grid-style">
                    {" "}
                    <span className="truncate flex-center">Date</span>
                  </span>
                </div>
                {tutorBioLoader ? (
                  <div className="flex-center-center">
                    <Spinner
                      animation="border"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                ) : employmentData?.length ? (
                  employmentData.map((empl, index) => {
                    return (
                      <div key={index} className="h4-head-div">
                        <div className="h4-head-style">
                          <span>{empl.employerName}</span>
                          <span>{empl.jobTitle}</span>
                          <span>{`${new Date(empl.startDate).getFullYear()} - ${
                            empl.isCurrentJob
                              ? "present"
                              : new Date(empl.endDate).getFullYear()
                          }`}</span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  ""
                )}
                {/* <div className="textmore-style">Report this profile</div> */}
              </div>
          </Col>
        </Row>
        </div>
      </div>
    );
  }
}
const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;

  return {
    tutorSettingData,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(PreviewProfile);
